/**
 * Admin authentication configuration.
 *
 * Default password: hound365admin
 *
 * To change the password, run this in your browser console or Node:
 *   const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode('YourNewPassword'))
 *   console.log(Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,'0')).join(''))
 *
 * Then paste the resulting hex string as ADMIN_PASSWORD_HASH below and redeploy.
 */
export const ADMIN_PASSWORD_HASH =
  'f222153d12ed7d479c657ca171edc82ca76fa0917125d39295f2fa72ae06fbd4'

/** How long (ms) an admin session lasts before requiring re-login. Default: 4 hours. */
export const SESSION_TTL_MS = 4 * 60 * 60 * 1000

/** localStorage key for persisted content overrides */
export const OVERRIDES_STORAGE_KEY = 'partner-training-overrides'

/** sessionStorage key for admin session */
export const SESSION_STORAGE_KEY = 'partner-training-admin-session'
